// extracted by mini-css-extract-plugin
export default {"box":"Home_box__+rhL7","img":"Home_img__tVQFi","text":"Home_text__TGRMu","welcome":"Home_welcome__Dk4HM","name":"Home_name__jV7qF"};